import { type PensionContractType } from "@repo/logic";
import { DocumentsList } from "@repo/ui";
import { type FC, useEffect, useState } from "react";
import { useContractId } from "../../context/ContractIDContext";
import { useContractTypeContext } from "../../context/ContractTypeContext";
import { usePensionDocuments } from "../../queryHooks";
import { ErrorBoundaryWithAsyncContext } from "../ErrorBoundary";
import { DefaultErrorUI } from "../ErrorBoundary/DefaultErrorUi";
import HelpBox from "../InfoBox/HelpBox";

export const Docs: FC = () => {
    const { contractId: id } = useContractId();
    const { contractType } = useContractTypeContext();
    const [docsEndpointErrorCode, setDocsEndpointErrorCode] = useState<number | undefined>();

    const result = usePensionDocuments({
        id,
        type: contractType as PensionContractType,
    });

    useEffect(() => {
        if (result.isError) {
            const maybeError = result.error as { errorResponse?: { code?: number } } | undefined;
            setDocsEndpointErrorCode(maybeError?.errorResponse?.code);
        }
    }, [result.error, result.isError]);

    return (
        <DocumentsList
            documents={result.data}
            isLoading={result.isLoading}
            isError={result.isError}
            errorCode={docsEndpointErrorCode}
        />
    );
};

const DocumentTab: FC = () => {
    return (
        <>
            <ErrorBoundaryWithAsyncContext fallbackUI={DefaultErrorUI}>
                <Docs />
            </ErrorBoundaryWithAsyncContext>
            <HelpBox noImage />
        </>
    );
};

export default DocumentTab;
